'use strict';
export default {
  methods: {
    contrastarSegip (params) {
      return new Promise((resolve, reject) => {
        this.$storage.set('token', process.env.TOKEN_EXTERNO);
        this.$service
        .post(`djbr_registro/contrastacion_segip_externo`, params)
        .then(response => {
          this.$storage.remove('token');
          if (response) {
            resolve(response);
          } else {
            resolve({
              finalizado: false
            });
          }
        })
        .catch(e => {
          console.log(e);
          resolve({
            finalizado: false
          });
        });
        this.$storage.remove('token');
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/portal/mixins/segip.js